module.exports = __webpack_public_path__ + "media/images/logos/linked-in-ae18012e0134dc8c5f91e39ef366d7ce.svg";